import React from 'react';
import makeAsyncScriptLoader from 'react-async-script';
import AddToCart from './AddToCart';

// const URL = "//cdn.foxycart.com/stofflove/foxycart.jsonp.sidecart.min.1507842523.js";
const URL = '//cdn.foxycart.com/checkout.stoff.love/loader.js';

const Loader = makeAsyncScriptLoader(
    AddToCart, URL,
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/addtocart/AddToCartScriptLoader.js